// extracted by mini-css-extract-plugin
module.exports = {"month":"_3aG8Z","sr-only":"_3mlvg","srOnly":"_3mlvg","text":"_2sKP3","disabled":"_26A6r","today":"_2Bs4m","selected":"_3k-Y8"};